import styled from 'styled-components'
import { Separator, Text } from '@sketch/components'

export const InfoBlock = styled(Text.Div).attrs({
  textStyle: 'copy.primary.standard.D',
})`
  display: flex;
  gap: 4px;
  margin-top: 12px;
`

export const StyledSeparator = styled(Separator)`
  margin: 24px 0;
`
